import React, { useState, useEffect } from "react";
import { Table, Button, Row, Col, Card, Form } from "react-bootstrap";
import moment from "moment";
import { Link } from "react-router-dom";
import {
  deleteAwardtype,
  getAwardtypes,
} from "../../../../services/AwardtypeService";
import {
  DatatableWrapper,
  TableBody,
  TableHeader,
  PaginationOptions,
  Pagination,
} from "react-bs-datatable";

const AwardtypeList = () => {
  const [awardtypes, setAwardtypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterText, setFilterText] = useState("");

  useEffect(() => {
    fetchAwardtypes();
  }, []);

  const fetchAwardtypes = async () => {
    try {
      const data = await getAwardtypes();
      setAwardtypes(data);
    } catch (error) {
      console.error("Error fetching awardtypes:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteAwardtype(id);
      fetchAwardtypes(); // Refresh list after deletion
      console.log("Awardtypes deleted successfully");
    } catch (error) {
      console.error("Error deleting awardtype:", error);
    }
  };

  // Table headers for the datatable
  const header = [
    { prop: "label", title: "Label" },
    { prop: "value", title: "Value" },
    { prop: "type", title: "Type" },
    { prop: "createdAt", title: "Created At" },
    { prop: "updatedAt", title: "Updated At" },
    {
      prop: "actions",
      title: "Actions",
      cell: (row) => (
        <>
          <Link
            to={"/settings/awardtypes/edit/" + row._id}
            variant="primary"
            className="btn btn-primary shadow btn-xs sharp me-1"
          >
            <i className="fa fa-pencil"></i>
          </Link>
          <Button
            variant="danger"
            className="btn btn-danger shadow btn-xs sharp me-1"
            onClick={() => handleDelete(row._id)}
          >
            <i className="fa fa-trash"></i>
          </Button>
        </>
      ),
    },
  ];

  // Format data for the table
  const tableData = awardtypes.map((awardtype) => ({
    label: awardtype.label,
    value: awardtype.value,
    type: awardtype.type,
    createdAt: moment(awardtype.createdAt).format("YYYY-MM-DD"),
    updatedAt: moment(awardtype.updatedAt).format("YYYY-MM-DD"),
    _id: awardtype._id, // Include for delete/edit actions
  }));

  // Filter the data based on the awardtype label
  const filteredData = tableData.filter(
    (item) =>
      item.label && item.label.toLowerCase().includes(filterText.toLowerCase())
  );

  return (
    <Card>
      <div className="card-body">
        <Row>
          <Col xs={12}>
            <h4>Awardtype List</h4>
            <Link
              variant="primary"
              to={"/settings/awardtypes/add"}
              className="mb-4 d-flex justify-content-end"
            >
              <Button>Add Award Type</Button>
            </Link>

            <DatatableWrapper
              body={filteredData} // Use filtered data for the table
              headers={header}
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 5, // Set rows per page
                  options: [5, 10, 15], // Options for rows per page
                },
              }}
            >
              <Row className="mb-4">
                <Col
                  xs={12}
                  lg={4}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Form.Control
                    type="text"
                    placeholder="Search by Awardtype Label"
                    value={filterText}
                    onChange={(e) => setFilterText(e.target.value)}
                  />
                </Col>
              </Row>

              <Table>
                <TableHeader />
                <TableBody />
              </Table>

              <Row>
                <Col className="d-flex flex-col justify-content-start">
                  <PaginationOptions />
                </Col>
                <Col className="mt-4 d-flex  justify-content-end align-items-end">
                  <Pagination />
                </Col>
              </Row>
            </DatatableWrapper>
          </Col>
        </Row>
      </div>
    </Card>
  );
};

export default AwardtypeList;
